import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";
import {store} from '../../../store';

export const issuerDomainMapService = {
  getAllissuerDomainMappings,
  createIssuerDomainMapping,
  viewIissuerDomainMapping
};

function getAllissuerDomainMappings(params) {
  return apiCall("GET", API_URLS.ISSUERS.GET_ALL_MAPPINGS, null, null, params);
}

function createIssuerDomainMapping(request, id) {
  const method = id ? "PUT" : "POST";
  return apiCall(method, API_URLS.ISSUERS.DOMAIN_MAPPINGS_URI, null, request);
}

function viewIissuerDomainMapping(id) {
  const domain = store.getState().currentUser.response.domainCode;
  let url = API_URLS.ISSUERS.DOMAIN_MAPPINGS_URI;
  if (domain === "ISW") {
    url = API_URLS.ISSUERS.DOMAIN_MAPPINGS_URI_ADMIN;
  }
  return apiCall("GET", url, null, null, {
    domainCode: id
  });
}
